/*
  Service actions
*/
// Libraries
import { apollo } from '@/plugins/apollo'

// graphql files
import list from 'GraphQL/queries/crashes/list.gql'

export default {
  async getList ({ state, dispatch, commit, rootState }, payload = false) {
    if (payload) {
      commit('setLoading', true, { root: true })
    }

    await apollo.query({
      query: list,
      variables: {
        apiToken: rootState.users.entity.apiToken
      },
      fetchPolicy: 'no-cache'
    }).then((response) => {
      const { status, result } = response.data.crashes

      switch (status) {
        case 'OK':
          commit('setCrashes', result)
          break

        case 'UNPROCESSABLE':
          commit('toggleSnackbar', undefined, { root: true })
          break
      }
    }).catch((error) => {
      commit('toggleSnackbar', undefined, { root: true })
    }).finally(() => {
      if (payload) {
        commit('setLoading', false, { root: true })
      }
    })
  }
}
